export default "__VITE_ASSET__D0eY7Vzf__"